export interface RouteServiceOptions {
  centerKey?: boolean | string;
  zoomKey?: boolean | string;
  projectionKey?: boolean | string;
  contextKey?: boolean | string;
  searchKey?: boolean | string;
  visibleOnLayersKey?: boolean | string;
  visibleOffLayersKey?: boolean | string;
}
